import { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import AuthContext from "../../context/AuthContext";

export default function CompanyCreation() {
  const ctxAuth = useContext(AuthContext);

  if (ctxAuth.userDetails.hasCompany) {
    return <Navigate to="/kyc-documents/company-document" replace={true} />;
  }

  // if (path === "/company-document" && companyDetails.companyDetails.id === 0) {
  //   return <Navigate to="/company-setup" replace={true} />;
  // }

  // if (path === "company-setup" && companyDetails.companyDetails.id !== 0) {
  //   return <Navigate to="/company-document" replace={true} />;
  // }

  return <Outlet />;
}
